import { getStoredSession } from '../utils/sessionManager';

class SessionService {
  constructor() {
    this.baseUrl = process.env.REACT_APP_USER_API_URL || 'https://dev-opus-users.aelive.cloud';
    this.sessionId = this.getOrCreateSessionId();
  }

  getOrCreateSessionId() {
    let sessionId = localStorage.getItem('aedrive_session_id');
    if (!sessionId) {
      sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      localStorage.setItem('aedrive_session_id', sessionId);
    }
    return sessionId;
  }

  getDeviceInfo() {
    return {
      browser: this.getBrowserName(),
      os: this.getOSName(),
      platform: navigator.platform || 'unknown',
      screen_resolution: `${window.screen.width}x${window.screen.height}`,
      user_agent: navigator.userAgent
    };
  }

  getBrowserName() {
    const ua = navigator.userAgent;
    if (ua.includes('Chrome')) return 'Chrome';
    if (ua.includes('Firefox')) return 'Firefox';
    if (ua.includes('Safari')) return 'Safari';
    if (ua.includes('Edge')) return 'Edge';
    return 'Unknown';
  }

  getOSName() {
    const ua = navigator.userAgent;
    if (ua.includes('Windows')) return 'Windows';
    if (ua.includes('Mac')) return 'macOS';
    if (ua.includes('Linux')) return 'Linux';
    if (ua.includes('Android')) return 'Android';
    if (ua.includes('iOS')) return 'iOS';
    return 'Unknown';
  }

  async createOrUpdateSession(fixtureId = undefined, rendererId = undefined) {
    try {
      const session = getStoredSession();
      if (!session?.orgId || !session?.userId) {
        return null;
      }

      const competitionId = localStorage.getItem('selectedCompetitionId');
      const seasonId = localStorage.getItem('selectedSeasonId');
      const storedFixtureId = fixtureId !== undefined 
        ? fixtureId 
        : (localStorage.getItem('selectedFixtureId') || undefined);

      const requestBody = {
        user_id: session.userId,
        user_name: session.username,
        organization_id: session.orgId,
        session_id: this.sessionId,
        device_info: this.getDeviceInfo(),
      };

      if (storedFixtureId !== undefined && storedFixtureId !== null && storedFixtureId !== '') {
        requestBody.fixture_id = storedFixtureId;
      }
      if (competitionId && competitionId !== null && competitionId !== '') {
        requestBody.competition_id = competitionId;
      }
      if (seasonId && seasonId !== null && seasonId !== '') {
        requestBody.season_id = seasonId;
      }

      const response = await fetch(`${this.baseUrl}/sessions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': session.accessKey ? `Bearer ${session.accessKey}` : undefined,
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('Failed to create/update session:', errorData);
        return null;
      }

      const data = await response.json();
      
      if (data.data?.session_id && data.data.session_id !== this.sessionId) {
        this.sessionId = data.data.session_id;
        localStorage.setItem('aedrive_session_id', this.sessionId);
      }
      
      return {
        session: data.data,
        redirect_path: data.redirect_path,
        existing_session: data.existing_session,
        message: data.message
      };
    } catch (error) {
      console.error('Error creating/updating session:', error);
      return null;
    }
  }

  async updateSession(fixtureId = null, rendererId = null) {
    try {
      const session = getStoredSession();
      if (!session?.orgId || !session?.userId) {
        return;
      }

      const competitionId = localStorage.getItem('selectedCompetitionId');
      const seasonId = localStorage.getItem('selectedSeasonId');
      const storedFixtureId = fixtureId !== null ? fixtureId : localStorage.getItem('selectedFixtureId');
      const requestBody = {};
      
      if (storedFixtureId !== null && storedFixtureId !== undefined && storedFixtureId !== '') {
        requestBody.fixture_id = storedFixtureId;
      }
      
      if (competitionId && competitionId !== null && competitionId !== '') {
        requestBody.competition_id = competitionId;
      }
      if (seasonId && seasonId !== null && seasonId !== '') {
        requestBody.season_id = seasonId;
      }

      if (Object.keys(requestBody).length === 0) {
        return;
      }

      const response = await fetch(`${this.baseUrl}/sessions/user/${session.userId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': session.accessKey ? `Bearer ${session.accessKey}` : undefined,
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('Failed to update session:', errorData);
      }
    } catch (error) {
      console.error('Error updating session:', error);
    }
  }

  async deleteSession() {
    try {
      const session = getStoredSession();
      if (!session?.orgId || !session?.userId) {
        return;
      }

      const response = await fetch(`${this.baseUrl}/sessions/user/${session.userId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': session.accessKey ? `Bearer ${session.accessKey}` : undefined,
        },
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('Failed to delete session:', errorData);
      }
    } catch (error) {
      console.error('Error deleting session:', error);
    }
  }
}

const sessionService = new SessionService();
export default sessionService;
